module.exports = __webpack_public_path__ + "static/media/LogoMoncacao.49c42ec8.png";